import React, { memo } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

const MetadataTags = ({ tags }) => {

    if(!tags) {

        return null;

    }
    
    return (
        <div className='metadata__tags'>
            <span className='metadata__tags-label'>Tags: </span>
            <ul className='metadata__tags-list'>
                {tags.map((tag, index) => {

                    return (
                        <li key={index} className='metadata__tags-list-item'>
                            {tag}
                        </li>
                    );

                })}
            </ul>
        </div>
    );

};

MetadataTags.propTypes = {
    tags: PropTypes.arrayOf(PropTypes.node),
};

export default memo(MetadataTags);
